// Main Component Export
export { default as Shell } from './Shell';

// Export prop types
export type { Props as ShellProps } from './Shell';
